/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .title[_ngcontent-%COMP%]{color:#2d2d2d;font-size:2em;padding:5px;font-weight:300}"];
export { styles as styles };
